import React from 'react';
import { Typography, makeStyles, Box } from '@material-ui/core';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

import { Category } from 'domain/types';
import CustomA from 'components/ui/links/CustomA';

interface CategoryNavigationItemProps {
  category: Category;
  isSelected?: boolean;
}

const CategoryNavigationItem: React.FC<CategoryNavigationItemProps> = ({
  category: {
    slug,
    name,
    smallImage: { url }
  },
  isSelected = false
}): JSX.Element => {
  const classes = useStyles();

  return (
    <Link href={`/shop/${slug}#product-list`} passHref scroll={false}>
      <CustomA className={classes.container}>
        <Box>
          <Image src={url} quality={75} width={133} height={133} />
        </Box>

        <Typography
          className={classNames(classes.text, isSelected && classes.textSelected)}
          variant="h6"
          component="h2"
        >
          {name}
        </Typography>
      </CustomA>
    </Link>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  text: {
    fontWeight: 400,
    fontSize: '0.85rem',
    textAlign: 'center',
    ['&:hover']: {
      textDecoration: 'underline'
    }
  },
  textSelected: {
    fontWeight: 700,
    color: theme.palette.primary.main
  }
}));

export default CategoryNavigationItem;
